// Translation: Utility > Loading error (Arabic)
export default Object.freeze({
	description: '',
	title: ''
})
